import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Translation resources
const resources = {
  es: {
    translation: {
      // Main titles and headers
      "title": "Tu foto carnet, sin salir de casa",
      "subtitle": "Proceso sencillo de creación de tu foto carnet tranquilamente en tu casa. Solo tres pasos",
      
      // SEO content
      "seoDescription": "Servicio rápido y profesional para crear foto carnet que cumple con los requisitos oficiales para DNI, pasaporte, NIE y otros documentos oficiales en España.",
      "seoTechnology": "Nuestra tecnología de detección facial automática garantiza fotos perfectas con el tamaño y formato correcto.",
      
      // Features
      "features": {
        "fast": {
          "title": "Rápido",
          "description": "Obtén tu foto en segundos"
        },
        "official": {
          "title": "Oficial",
          "description": "Cumple con normativas españolas"
        },
        "easy": {
          "title": "Fácil",
          "description": "Sin conocimientos técnicos"
        }
      },
      
      // Photo action buttons
      "takePhoto": "Tomar Foto",
      "chooseFromGallery": "Elegir en la Galería",
      
      // Face detection messages
      "faceDetectionLoaded": "Modelos de detección facial cargados",
      "faceDetectionSkipped": "Omitiendo carga de modelos de detección facial en este dispositivo",
      "faceDetectionMobileSkipped": "Omitiendo carga de modelos de detección facial para mejorar el rendimiento en dispositivos móviles",
      "faceDetectionError": "Error al cargar los modelos de detección facial.",
      "noFaceDetected": "No se detectó ningún rostro. Por favor, intente con otra imagen.",
      "faceDetectionFailed": "Error al detectar el rostro.",
      
      // Processing steps
      "steps": {
        "cropping": "Recortando",
        "backgroundRemoval": "Eliminación de fondo",
        "resizing": "Redimensionando",
        "analyzing": "Analizando"
      },
      
      // Modal and processing
      "processing": "Procesando...",
      "processingPhoto": "Procesando su foto...",
      "displayOptions": "Opciones de visualización:",
      "singlePhoto": "Foto Individual",
      "assembledPhotos": "Fotos Ensambladas",
      
      // Payment
      "completePurchase": "Finaliza tu pedido",
      "total": "Total",
      "photoProcessingService": "Servicio de Procesamiento de Fotos de Carnet",
      "creditCard": "Tarjeta de Crédito",
      "payWithCard": "Pagar con Tarjeta",
      "paymentMethods": "Métodos de Pago",
      "selectPaymentMethod": "Selecciona un método de pago",
      "securePayment": "Pago seguro",
      "card": "Tarjeta",
      "paymentDescription": "Completa el pago seguro con tarjeta a través de PAYCOMET.",
      "googlePayDescription": "Paga rápido y seguro con Google Pay.",
      "orPayWithCard": "o pagar con tarjeta",
      "applePayDescription": "Paga rápido y seguro con Apple Pay.",
      "secureNote": "Google Pay se muestra con el botón oficial de Google y la tarjeta se procesa de forma segura con Paycomet.",
      "privacyPolicy": "Política de Privacidad",
      
      // Language selection
      "language": "Idioma",
      "spanish": "Español",
      "english": "Inglés",
      // Menu
      "menu": {
        "menu": "Menú",
        "home": "Inicio",
        "terms": "Términos y Condiciones",
        "contact": "Contacto"
      },
      // Photo confirmation
      "confirmPhoto": "Confirmar",
      // Contact form
      "contact": {
        "title": "Contáctanos",
        "name": "Tu Nombre",
        "email": "Tu Correo",
        "message": "Tu Mensaje",
        "send": "Enviar Mensaje",
        "thankYou": "¡Gracias!",
        "sent": "Tu mensaje ha sido enviado."
      },
      
      // Legal links
      "avisoLegal": "Aviso Legal",
      "terminosDevoluciones": "Términos y Devoluciones"
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'es', // Force Spanish language
    fallbackLng: 'es', // Default to Spanish
    debug: false,
    
    interpolation: {
      escapeValue: false, // React already does escaping
    },
  });

export default i18n;
